import React, {useEffect, useRef, useState} from 'react'
import {getTransferData, savePhyVeriData, getPhyVeriMaster, getCountVinNo, getTagChildCount} from '../../../services/asset.service';
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import FromFieldSelect from '../../../atoms/FromFieldSelect';
import * as CryptoJS from "crypto-js";
import '../AssetInfo/PhysicalVerificationForm.css';

const TEXT_REGEX = /^[a-z0-9-_ ]$/;

Date.prototype.dbFormatedDate = function () {
    let year  = this.getFullYear();
    let month = this.getMonth() + 1;
    let day   = this.getDate();
    if (month < 10) { month = '0' + month; }
    if (day   < 10) { day   = '0' + day;   }
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte   = new Date(dateString);
        let year  = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day   = dte.getDate();
        if (month < 10) { month = '0' + month; }
        if (day   < 10) { day   = '0' + day;   }
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

function PhysicalVerification() {
    const textRef = useRef();
    const errRef  = useRef();

    const [tag,              setTag]              = useState(0);
    const [assetInfo,        setAssetInfo]        = useState({});

    const [pvtableno,        setPvTableNo]        = useState('');
    const [ErrPvTableNo,     setErrPvTableNo]     = useState('');
    const [division,         setDivision]         = useState('');
    const [ErrDivision,      setErrDivision]      = useState('');
    const [validText,        setValidText]        = useState(false);

    const [method,           setMethod]           = useState('');
    const [ErrMethod,        setErrMethod]        = useState('');
    const [lastverifydate,   setLastVerifyDate]   = useState('');
    const [ErrLastVerifyDate,setErrLastVerifyDate]= useState('');
    const [lastverifyremark, setLastVerifyRemark] = useState('');
    const [ErrLastVerifyRemark,setErrLastVerifyRemark] = useState('');
    const [userlocation,     setUserLocation]     = useState('');
    const [ErrUserLocation,  setErrUserLocation]  = useState('');
    const [reasonforchhange, setReasonForChhange] = useState('');
    const [ErrReasonForChange,setErrReasonForChange] = useState('');
    const [verifystatus,     setVerifyStatus]     = useState('');
    const [ErrVerifyStatus,  setErrVerifyStatus]  = useState('');
    const [assetstatus,      setAssetStatus]      = useState('');
    const [ErrAssetStatus,   setErrAssetStatus]   = useState('');
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pvMaster, setPvMaster]                 = useState([]);
    const [pvMasterTable, setPvMasterTable]       = useState('');
    const [errMsg,  setErrMsg]  = useState('');
    const [success, setSuccess] = useState(false);
    const [VINAndRef, setVINAndRef] = useState('');
    const [PrefixVINAndRef, setPrefixVINAndRef] = useState('');
    useEffect(() => {}, []);

    useEffect(() => {
        setValidText(TEXT_REGEX.test(division));
    }, [division]);

    const handleClick = async (e) => {
        e.preventDefault();
        var valid_Name = true;

        if (pvMasterTable === '')       { setErrPvTableNo('Pv Table is required');               valid_Name = false; } else { setErrPvTableNo(''); }
        if (division === '')        { setErrDivision('Division is required');                 valid_Name = false; } else { setErrDivision(''); }
        if (method === '')          { setErrMethod('Method is required');                     valid_Name = false; } else { setErrMethod(''); }
        if (lastverifydate === '')  { setErrLastVerifyDate('Last Verification Date is required'); valid_Name = false; } else { setErrLastVerifyDate(''); }
        if (lastverifyremark === '') { setErrLastVerifyRemark('Last Verification remark is required'); valid_Name = false; } else { setErrLastVerifyRemark(''); }
        if (userlocation === '')    { setErrUserLocation('User Location is required');        valid_Name = false; } else { setErrUserLocation(''); }
        if (reasonforchhange === '') { setErrReasonForChange('Reason For Change is required'); valid_Name = false; } else { setErrReasonForChange(''); }
        if (verifystatus === '')    { setErrVerifyStatus('Status of verification is required'); valid_Name = false; } else { setErrVerifyStatus(''); }
        if (assetstatus === '')     { setErrAssetStatus('Status is required');                valid_Name = false; } else { setErrAssetStatus(''); }

        if (valid_Name) { saveData(); } else { return false; }
    }

    const resetPVInfo = function () {
        setTag('');
        setDivision('');
        setPvMasterTable('');
        setLastVerifyDate('');
        setLastVerifyRemark('');
        setUserLocation('');
        setReasonForChhange('');
        setVerifyStatus('');
    }

    const getTagInfo = function () {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': tag},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        getTransferData(oData).then(function (res) {
            if (res?.data?.data) {
                let aInfo = res.data.data;
                setAssetInfo(res.data.data);
                if(aInfo.vin_no){
                    setPrefixVINAndRef(aInfo.vin_no)
                }
            } else {
                setAssetInfo({});
                setErrMsg('Assets Not Found');
            }
        });
    }
    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;
    useEffect(() => {
            const offset = calculateOffset(page, pageSize);
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'offset': offset, 'pageSize': pageSize },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    
            const oData = { 'token': encryptedData };
    
            getPhyVeriMaster(oData)
                .then(res => {
                    if (res?.data?.data?.length) {
                        setPvMaster(res.data.data);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching data:', error);
                    setErrMsg(error.message || 'Error fetching data');
                })
                .finally(() => {
                    setLoading(false);
                });
            if (PrefixVINAndRef) {
                            let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
                              'param_data': {'vin_no': PrefixVINAndRef},
                              'authToken': sessionStorage.getItem('LoggedInToken'),
                            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                            let oData1 = {'token':EncryptData1};
                            getCountVinNo(oData1).then(res=>{
                               //setClasifications(res.data.data);
                               generateVINAndRef(res?.data?.total);
                            });
                        }    
        }, [PrefixVINAndRef]);
    const generateVINAndRef = function(table_no, lastNumber=''){
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // zero-padded month
        const year = String(date.getFullYear()).slice(-2);          // last 2 digits of year
        const divisionCode = sessionStorage.getItem('LoggedInDivisionCode') || '0000';

        const nextSerial = String(lastNumber + 1).padStart(5, '0'); // e.g., 00001
        if(lastNumber<0){ 
            let previnCode = `VIN-${table_no}/`;
            //alert(previnCode);
            setPrefixVINAndRef(previnCode);
        }else{
        let vinCode = `VIN-${table_no}/${nextSerial}`;
        setVINAndRef(vinCode);
        }
        //const refTag = `${nextSerial}-1`;
    };
    const generateSubVINAndRef = function(vinCode){
        if (typeof vinCode === 'string' && vinCode.trim() !== ''){
            // Extract base VIN (before any dash)
            const baseVIN = vinCode.split('/')[0];
            let EncryptData2 = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'vin_no': baseVIN},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData2 = {'token':EncryptData2};
            getCountVinNo(oData2).then(res=>{ //console.log(res?.data?.total);
                const count = res?.data?.total || 0;
                const nextSerial = String(count + 1).padStart(5, '0'); // e.g., 00001
                let sub_vinCode = `${baseVIN}/${nextSerial}`;
                //alert(vinCode);
                setVINAndRef(sub_vinCode);
            });
        }
        //const refTag = `${nextSerial}-1`;
    };
    const handlePvMaster = (e) => {
        const selectedId = e.target.value;
        const selectedItem = pvMaster.find(item => String(item.id) === String(selectedId));
        
        setPvMasterTable(selectedId);
        if (selectedItem) {
            generateSubVINAndRef(`VIN-${selectedItem.phy_varify_table_name}/`);
        }
    };
    const saveData = function () {
        try {
            var obj = {
                'param_data': {
                    'tag': tag,
                    'vin_no': VINAndRef,
                    'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                    'division_id': sessionStorage.getItem('LoggedInDivisionId'),
                    'division': division,
                    'pv_table_no': pvMasterTable,
                    'last_verification_date': lastverifydate,
                    'method': method,
                    'last_verification_remarks': lastverifyremark,
                    'change_user_location': userlocation,
                    'reason_for_change': reasonforchhange,
                    'status_of_verification': verifystatus,
                    'status': assetstatus,
                }, 'token': sessionStorage.getItem('LoggedInToken')
            }
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = {'token': EncryptData}
            savePhyVeriData(oData1).then(function (res) {
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    setPvTableNo('');
                    resetPVInfo();
                }
            });
        } catch (err) {
            setSuccess(false);
            setErrMsg(err.data?.message || 'Insert/Update Failed');
            if (!err?.data)                  { setErrMsg('No Server Response'); }
            else if (err.data?.status === 409) { setErrMsg('Username Taken'); }
            else                             { setErrMsg('Insert/Update Failed'); }
        }
    }

    return (
        <div className="al-page" id="all-asset-list-page">

            {/* ── PAGE HEADER ── */}
            
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-clipboard2-check-fill"></i>
                    </div>
                    <div>
                        <div className="al-page-header-text">
                        <h5 className="al-page-title">Physical Verification</h5>
                        <p className="al-page-subtitle">Create and submit a new physical verification record</p>
                    </div>
                </div>
            </div>
            {/* ── ALERTS ── */}
            {success && (
                <div className="pvf-alert pvf-alert-success" id="pvf-alert-success" role="alert">
                    <i className="bi bi-check-circle-fill"></i>
                    {success}
                </div>
            )}
            {errMsg && !success && (
                <div className="pvf-alert pvf-alert-danger" id="pvf-alert-danger" role="alert">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                    {errMsg}
                </div>
            )}
            </div>
            {/* ══════════════════════════════
                SECTION 1 — TAG LOOKUP
            ══════════════════════════════ */}
            <div className="al-filter-card" id="pvf-tag-card">
                <div className="al-filter-card-header" id="pvf-tag-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-search"></i>
                        Asset Tag Lookup
                    </span>
                </div>
                <div className="al-filter-card-body" id="pvf-tag-card-body">
                    <div className="pvf-tag-row" id="pvf-tag-row">
                        <div className="pvf-tag-field" id="pvf-tag-field">
                            <label className="al-filter-label" htmlFor="pvf-tag-input">
                                <i className="bi bi-tag"></i>
                                Asset TAG
                                <span className="al-required-star">*</span>
                            </label>
                            <input
                                id="pvf-tag-input"
                                type="text"
                                className="al-form-input"
                                placeholder="Enter the asset TAG..."
                                onChange={(e) => setTag(e.target.value)}
                            />
                        </div>
                        <div className="pvf-tag-action" id="pvf-tag-action">
                            <button
                                id="pvf-btn-search"
                                onClick={getTagInfo}
                                className="al-btn al-btn-primary"
                            >
                                <i className="bi bi-search"></i>
                                Search Asset
                            </button>
                        </div>
                    </div>

                    {/* Asset info strip — shown when asset is found */}
                    {assetInfo && Object.keys(assetInfo).length > 0 && (
                        <div className="pvf-asset-strip" id="pvf-asset-strip">
                            <i className="bi bi-check-circle-fill pvf-asset-strip-icon"></i>
                            <span className="pvf-asset-strip-label">Asset found:</span>
                            <span className="pvf-asset-strip-tag">{assetInfo.tag || tag}</span>
                            {assetInfo.asset_name && (
                                <span className="pvf-asset-strip-name">— {assetInfo.asset_name}</span>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* ══════════════════════════════
                SECTION 2 — VERIFICATION DETAILS
            ══════════════════════════════ */}
            <div className="al-filter-card" id="pvf-details-card">
                <div className="al-filter-card-header" id="pvf-details-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-clipboard-data"></i>
                        Verification Details
                    </span>
                </div>
                <div className="al-filter-card-body" id="pvf-details-card-body">
                    {/* Row 1: PV Table + Method */}
                    <div className="pvf-form-grid" id="pvf-grid-row1">
                        <div className="al-filter-group" id="pvf-field-pvtable">
                            <label className="al-filter-label" htmlFor="pvf-select-pvtable">
                                <i className="bi bi-table"></i>
                                PV Table No
                                <span className="al-required-star">*</span>
                            </label>
                            <select onChange={handlePvMaster} className="form-select form-select-sm">
                                <option value="">Select PV Master Table</option>
                                {pvMaster && pvMaster.length > 0 ? (
                                    pvMaster.map((option) => (
                                        <option key={option.id}
                                                value={option.id} 
                                                data-name={option.phy_varify_table_name}>
                                            {option.phy_varify_table_name}
                                        </option>
                                    ))
                                ) : (<option value="">No Data</option>)}
                            </select>
                            {ErrPvTableNo && (
                                <span className="al-field-error" id="pvf-err-pvtable">
                                    <i className="bi bi-exclamation-circle"></i>{ErrPvTableNo}
                                </span>
                            )}
                        </div>
                        <div className="al-filter-group" id="pvf-field-pvtable">
                            <label className="al-filter-label" htmlFor="pvf-select-pvtable">
                                <i className="bi bi-table"></i>
                                VIN (verification identification number)
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldText
                                label=""
                                inputValue={VINAndRef}
                                readOnly="readonly"
                            />
                            
                        </div>
                        

                    </div>

                    {/* Row 2: Last Verification Date + Last Verification Remark */}
                    <div className="pvf-form-grid" id="pvf-grid-row2">
                        <div className="al-filter-group" id="pvf-field-method">
                            <label className="al-filter-label" htmlFor="pvf-select-method">
                                <i className="bi bi-layers"></i>
                                Method
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldSelect
                                label=""
                                setSelectedValue={setMethod}
                                selectedValue={method}
                                values={["Flor to File", "File to floor"]}
                                setErrorMsg={ErrMethod}
                            />
                            {ErrMethod && (
                                <span className="al-field-error" id="pvf-err-method">
                                    <i className="bi bi-exclamation-circle"></i>{ErrMethod}
                                </span>
                            )}
                        </div>
                        <div className="al-filter-group" id="pvf-field-lastdate">
                            <label className="al-filter-label" htmlFor="pvf-input-lastdate">
                                <i className="bi bi-calendar-check"></i>
                                Last Verification Date
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldDate
                                label=""
                                inputValue={lastverifydate}
                                setInputValue={setLastVerifyDate}
                                setErrorMsg={ErrLastVerifyDate}
                            />
                            {ErrLastVerifyDate && (
                                <span className="al-field-error" id="pvf-err-lastdate">
                                    <i className="bi bi-exclamation-circle"></i>{ErrLastVerifyDate}
                                </span>
                            )}
                        </div>

                        

                    </div>

                    {/* Row 3: Change User Location + Division */}
                    <div className="pvf-form-grid" id="pvf-grid-row3">
                        <div className="al-filter-group" id="pvf-field-lastremark">
                            <label className="al-filter-label" htmlFor="pvf-input-lastremark">
                                <i className="bi bi-chat-left-text"></i>
                                Last Verification Remark
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldText
                                label=""
                                inputValue={lastverifyremark}
                                setInputValue={setLastVerifyRemark}
                                setErrorMsg={ErrLastVerifyRemark}
                            />
                            {ErrLastVerifyRemark && (
                                <span className="al-field-error" id="pvf-err-lastremark">
                                    <i className="bi bi-exclamation-circle"></i>{ErrLastVerifyRemark}
                                </span>
                            )}
                        </div>
                        <div className="al-filter-group" id="pvf-field-userlocation">
                            <label className="al-filter-label" htmlFor="pvf-select-userlocation">
                                <i className="bi bi-geo-alt"></i>
                                Change User Location
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldSelect
                                label=""
                                setSelectedValue={setUserLocation}
                                selectedValue={userlocation}
                                values={["Yes", "No"]}
                                setErrorMsg={ErrUserLocation}
                            />
                            {ErrUserLocation && (
                                <span className="al-field-error" id="pvf-err-userlocation">
                                    <i className="bi bi-exclamation-circle"></i>{ErrUserLocation}
                                </span>
                            )}
                        </div>

                        

                    </div>

                    {/* Row 4: Reason For Change */}
                    <div className="pvf-form-grid" id="pvf-grid-row4">
                        <div className="al-filter-group" id="pvf-field-division">
                            <label className="al-filter-label" htmlFor="pvf-input-division">
                                <i className="bi bi-diagram-3"></i>
                                Division
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldText
                                label=""
                                inputValue={division}
                                setInputValue={setDivision}
                                setErrorMsg={ErrDivision}
                            />
                            {ErrDivision && (
                                <span className="al-field-error" id="pvf-err-division">
                                    <i className="bi bi-exclamation-circle"></i>{ErrDivision}
                                </span>
                            )}
                        </div>
                        <div className="al-filter-group" id="pvf-field-reason">
                            <label className="al-filter-label" htmlFor="pvf-select-reason">
                                <i className="bi bi-question-circle"></i>
                                Reason For Change
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldSelect
                                label=""
                                setSelectedValue={setReasonForChhange}
                                selectedValue={reasonforchhange}
                                values={["Asset have some problem", "Asset have no problem"]}
                                setErrorMsg={ErrReasonForChange}
                            />
                            {ErrReasonForChange && (
                                <span className="al-field-error" id="pvf-err-reason">
                                    <i className="bi bi-exclamation-circle"></i>{ErrReasonForChange}
                                </span>
                            )}
                        </div>

                        

                    </div>

                </div>
            </div>

            {/* ══════════════════════════════
                SECTION 3 — VERIFICATION STATUS
            ══════════════════════════════ */}
            <div className="al-filter-card" id="pvf-status-card">
                <div className="al-filter-card-header" id="pvf-status-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-patch-check"></i>
                        Verification Status
                    </span>
                </div>
                <div className="al-filter-card-body" id="pvf-status-card-body">

                    <div className="pvf-form-grid" id="pvf-grid-status">

                        <div className="al-filter-group" id="pvf-field-verifystatus">
                            <label className="al-filter-label" htmlFor="pvf-select-verifystatus">
                                <i className="bi bi-clipboard-check"></i>
                                Verification Status
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldSelect
                                label=""
                                setSelectedValue={setVerifyStatus}
                                selectedValue={verifystatus}
                                values={[
                                    "Asset Fond in working Condition",
                                    "Asset Fond in Non-working Condition",
                                    "Asset Not found",
                                    "Other"
                                ]}
                                setErrorMsg={ErrVerifyStatus}
                            />
                            {ErrVerifyStatus && (
                                <span className="al-field-error" id="pvf-err-verifystatus">
                                    <i className="bi bi-exclamation-circle"></i>{ErrVerifyStatus}
                                </span>
                            )}
                        </div>

                        <div className="al-filter-group" id="pvf-field-assetstatus">
                            <label className="al-filter-label" htmlFor="pvf-select-assetstatus">
                                <i className="bi bi-toggle-on"></i>
                                Asset Status
                                <span className="al-required-star">*</span>
                            </label>
                            <FromFieldSelect
                                label=""
                                setSelectedValue={setAssetStatus}
                                selectedValue={assetstatus}
                                values={["Verified", "Not Verified"]}
                                setErrorMsg={ErrAssetStatus}
                            />
                            {ErrAssetStatus && (
                                <span className="al-field-error" id="pvf-err-assetstatus">
                                    <i className="bi bi-exclamation-circle"></i>{ErrAssetStatus}
                                </span>
                            )}
                        </div>

                    </div>

                    {/* ── Actions ── */}
                    <div className="al-filter-actions" id="pvf-form-actions">
                        <button
                            id="pvf-btn-save"
                            onClick={handleClick}
                            className="al-btn al-btn-primary"
                        >
                            <i className="bi bi-floppy2-fill"></i>
                            Save Record
                        </button>
                        <button
                            id="pvf-btn-reset"
                            type="button"
                            onClick={resetPVInfo}
                            className="al-btn al-btn-outline"
                        >
                            <i className="bi bi-arrow-counterclockwise"></i>
                            Reset
                        </button>
                    </div>

                </div>
            </div>
                            
        </div>
    );
}

export default PhysicalVerification;